import { createFileRoute } from '@tanstack/react-router';

import { ExperimentsScreen } from '@/screens/ExperimentsScreen';

export const Route = createFileRoute('/_app/experiments')({
  component: ExperimentsScreen,
});
